<template>
  <v-flex xs12>
    <steps v-model="currentStep" :steps="steps">
      <template slot="step1">
        <Solicitation
          :onCallback="solicitationCallback"
          :value="selectedItems"
          :reasons="reasons"
          :previousReasons="previousReasons"
        />
      </template>
      <template slot="step2">
        <Schedule
          :onCallback="scheduleCallback"
          :error="{}"
          :reasonTicketInfo="reasonTicketInfo"
          :technicalSchedule="technicalSchedule"
          :technicalDate="technicalDate"
        />
      </template>
      <template slot="step3">
        <Concluded
          :concludedDate="concludedDate"
          :reasonTicketInfo="reasonTicketInfo"
        />
      </template>
    </steps>
  </v-flex>
</template>

<script>
import Solicitation from './SolicitationStep';
import Schedule from './ScheduleStep';
import Concluded from './ConcludedStep';
import Steps from '@/components/layout/Steps';
export default {
  components: {
    Steps,
    Solicitation,
    Concluded,
    Schedule
  },
  props: {
    currentStep: Number,
    solicitationCallback: Function,
    selectedItems: Array,
    scheduleCallback: Function,
    concludedDate: Object,
    reasonTicketInfo: Array,
    reasons: Array,
    technicalSchedule: Array,
    technicalDate: Array,
    previousReasons: Array
  },
  data() {
    return {
      steps: [
        { description: 'Abrir Solicitação' },
        { description: 'Agendar Horário' },
        { description: 'Concluído' }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
@import '../../../../assets/scss/breakpoint';
.ticket {
  &__input {
    border: 1px lightgray solid;
    border-radius: 5px;

    padding: 0px 0px 5px;

    &__error {
      border: 1px #ff5252 solid;
    }

    >>> .v-input__slot {
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.02),
        0 1px 5px 0 rgba(0, 0, 0, 0.02) !important;

      textarea {
        margin: 0 !important;
      }
    }
  }
}
.field-spacing {
  @include breakpoint(not-mobile) {
    padding-left: 8px !important;
  }
  @include breakpoint(mobile) {
    padding-left: 0px !important;
  }
}
</style>



// WEBPACK FOOTER //
// ./src/views/support/ticket/technicalAssistance/TechnicalAssistanceSteps.vue